var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 25C22.0527 25 26.25 20.8027 26.25 15.625C26.25 10.4473 22.0527 6.25 16.875 6.25C11.6973 6.25 7.5 10.4473 7.5 15.625C7.5 20.8027 11.6973 25 16.875 25Z",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.25C27 15.8358 26.6642 15.5 26.25 15.5C25.8358 15.5 25.5 15.8358 25.5 16.25H27ZM16.25 19.25C15.8358 19.25 15.5 19.5858 15.5 20C15.5 20.4142 15.8358 20.75 16.25 20.75V19.25ZM25.5 16.25C25.5 16.7742 25.396 17.1633 25.1885 17.4746C24.98 17.7873 24.6165 18.0973 23.9615 18.3702C22.6125 18.9323 20.2472 19.25 16.25 19.25V20.75C20.2528 20.75 22.8875 20.4427 24.5385 19.7548C25.3835 19.4027 26.02 18.9314 26.4365 18.3067C26.854 17.6805 27 16.9758 27 16.25H25.5Z",
    fill: "#007FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 10C31.6463 10.8203 31.9606 11.7945 32.1751 12.8669C32.3896 13.9394 32.5 15.089 32.5 16.25C32.5 17.411 32.3896 18.5606 32.1751 19.6331C31.9606 20.7055 31.6463 21.6797 31.25 22.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5C35.7925 6.47646 36.4212 8.23006 36.8502 10.1605C37.2792 12.0909 37.5 14.1602 37.5 16.25C37.5 18.3398 37.2792 20.4091 36.8502 22.3395C36.4212 24.2699 35.7925 26.0235 35 27.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46973 31.2497C5.11244 29.2925 7.16378 27.7189 9.47962 26.6392C11.7955 25.5595 14.3196 25 16.8748 25C19.43 25 21.9541 25.5595 24.27 26.6392C26.5858 27.7189 28.6371 29.2926 30.2798 31.2498",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 13.25,
    width: 3.5,
    height: 4.75,
    rx: 1.25,
    stroke: "#007FA1",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAgent);
export default __webpack_public_path__ + "static/media/active-agent.679cb28029bee740952c92307ecdf86e.svg";
export { ForwardRef as ReactComponent };